var Vue = require('vue');
var VueI18n = require('vue-i18n');
Vue.use(VueI18n);

//import nls
var nls = require('./../config/nls.js');
var defaultLocale = localStorage.getItem("defaultLocale");
if (defaultLocale == null) {
    defaultLocale = nls.defaultLocale;
}
var i18n = new VueI18n({
    locale: defaultLocale, // set locale
    messages : nls.text, // set locale messages
});

// 获取组件引用
// var testC = require('./components/App.vue');
var header_comp = require('./../components/header.vue');
var body_comp = require('./../components/contact.vue');
var footer_comp = require('./../components/footer.vue');

window.vm = new Vue({
    i18n : i18n,  // VueI18n 插件
    el:"#app",
    components: {
        header_comp: header_comp,
        body_comp: body_comp,
        footer_comp: footer_comp
    }
});




//////////////////
// WEBPACK FOOTER
// ./src/js/contact.js
// module id = 153
// module chunks = 20